module.exports = __webpack_public_path__ + "static/media/logo.b44897fe.png";